import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MoneyService, SymbolService, TimeService } from '@easy-lib/modules/shared/services';
import { Store } from '@ngrx/store';
import { SettingStore } from '../setting/setting.store';
import * as soldItemsSelector from '@easy-lib/state/sold-items/sold-items.selector';

@Injectable({
	providedIn: 'root'
})
export class SoldItemsStore {
	store: Store = inject(Store);
	moneyService: MoneyService = inject(MoneyService);
	symbolService = inject(SymbolService);
	settingStore = inject(SettingStore);
	timeService = inject(TimeService);

	getLastSoldInsertTime$ = this.store.select(soldItemsSelector.getLastSoldItemsInsertTime);
	getPortfolioSoldItemWitchCalculation$ = (symbolIsin: string) =>
		this.store.select(soldItemsSelector.getSoldItemWithCalculation(symbolIsin));

	portfolioSoldItems$ = this.store.select(soldItemsSelector.getSoldItemsWithMarketData);
	portfolioSoldItems = toSignal(this.portfolioSoldItems$);

	portfolioSoldDPSItems$ = this.store.select(soldItemsSelector.getSoldItemsDPSList);
	soldItemTotalValues$ = this.store.select(soldItemsSelector.getSoldItemsTotalValues);

	getLoading$ = this.store.select(soldItemsSelector.getSoldItemsLoading);

	soldItemsExportExcelItems = this.store.selectSignal(soldItemsSelector.getSoldItemsForExcel);
}
